// Helper pour envoyer des événements à Umami.
// Conçu pour être robuste : si Umami n'est pas chargé (script bloqué, hors ligne,
// ad-blocker...), la fonction ne casse pas le site et reste silencieuse.

declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: Record<string, unknown>) => void;
    };
  }
}

export function trackEvent(name: string, data?: Record<string, unknown>): void {
  if (typeof window !== "undefined" && window.umami) {
    try {
      window.umami.track(name, data);
    } catch {
      // Silencieux : on ne casse pas l'expérience utilisateur si le tracking plante
    }
  }
}
